import {
  type MutableRefObject,
  type RefObject,
  useEffect,
  useState,
} from 'react';

const useVisibility = <T extends HTMLElement>(
  element: MutableRefObject<T> | RefObject<T | null>,
  fallback?: boolean,
) => {
  const [isVisible, setIsVisible] = useState(fallback);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      setIsVisible(entry.isIntersecting);
    });
    if (element.current) observer.observe(element.current);
  }, [element]);

  return isVisible ?? fallback;
};

export default useVisibility;
